import {Product} from '../../../common/types/product'
import {Rental} from '../../../common/types/rental'
import {getTimeDifferenceInMinutes} from '../../../common/utils/dateUtils'

export interface ProductsTimeBeingUsedData {
  id: string
  product: Product
  meanTime: number
  medianTime: number
  rentalCount: number
}

export const generateProductsTimeUsedData = (rentals: Rental[]): ProductsTimeBeingUsedData[] => {
  const productMap = new Map<string, {product: Product; durations: number[]}>()

  for (const rental of rentals) {
    const product = rental.product
    const id = product.id

    if (rental.rentEnd) {
      const duration = getTimeDifferenceInMinutes(rental.rentStart, rental.rentEnd)

      if (duration && duration > 1 && duration < 6 * 60) {
        if (!productMap.has(id)) {
          productMap.set(id, {product, durations: []})
        }
        productMap.get(id)!.durations.push(duration)
      }
    }
  }

  return Array.from(productMap.entries()).map(([id, {product, durations}]) => {
    const sorted = durations.slice().sort((a, b) => a - b)
    const count = durations.length
    const total = durations.reduce((sum, val) => sum + val, 0)
    const mean = total / count

    let median: number
    if (count % 2 === 0) {
      median = (sorted[count / 2 - 1] + sorted[count / 2]) / 2
    } else {
      median = sorted[Math.floor(count / 2)]
    }

    return {
      id,
      product,
      meanTime: Math.round(mean),
      medianTime: Math.round(median),
      rentalCount: count,
    }
  })
}
